import { useMutation } from '@tanstack/react-query';
import { BASE_API_URL } from '../consts/base-url';
import customFetch from '../utils/fetch';
export const useIngestDodProjectFiles = (claimId: string, recipientCode: string, claimPasscode: string, projectId: number) => {
  const {
    mutate,
    data,
    isPending,
    isSuccess,
    isError,
    error
  } = useMutation({
    mutationKey: ['ingestDoDProjectFiles', claimId, recipientCode, claimPasscode, projectId],
    mutationFn: async ({
      claimId,
      recipientCode,
      claimPasscode,
      projectId
    }: {
      claimId: string;
      recipientCode: string;
      claimPasscode: string;
      projectId: number;
    }) => {
      const response = await customFetch(`${BASE_API_URL}/batch/ingest/dod`, {
        method: 'POST',
        body: JSON.stringify({
          claimId,
          recipientCode,
          claimPasscode,
          projectId
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      });
      const {
        success,
        error,
        data
      } = (await response.json() as {
        success: boolean;
        error: string;
        data: {
          successfulUrls: string[];
          failedFiles: {
            objectName: string;
            reason: string;
          }[];
        };
      });
      if (!response.ok || !success) {
        throw new Error(`Failed on copying files from DoD Safe: ${error}`);
      }
      return {
        data
      };
    }
  });
  return {
    ingestDoDProjectFiles: mutate,
    actionStatus: data,
    isPending,
    isSuccess,
    isError,
    error
  };
};